import React from 'react';
import { withTranslation } from 'react-i18next';

// @material-ui
import {
    TextareaAutosize,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@mui/material';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import FileUpload from 'components/CustomUpload/FileUpload.js';

class addSpecialUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: '',
            usersState: '',
            companies: [],
            companiesState: '',
            torgid_company_id: '',
            msg: '',
            searchQuery: '',
            showAll: false,
            notify_app_users: false,
        };
    }

    componentDidMount() {
        this.checkAndSetSingleCompany();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.companies !== this.props.companies) {
            this.checkAndSetSingleCompany();
        }
    }

    checkAndSetSingleCompany = () => {
        const { companies } = this.props;
        const singleCompany = companies && companies.length === 1 ? companies[0] : null;

        if (singleCompany && this.state.companies.length === 0) {
            this.setState({
                companies: [singleCompany.id],
                companiesState: 'success',
            });
        }
    };

    isValidated() {
        if (this.state.msg === 'Allt rétt!' && this.state.companiesState === 'success') {
            return true;
        } else {
            if (this.state.msg !== 'Allt rétt!') {
                this.setState({ msg: 'Vinsamlega fylltu reitinn út' });
            }
            if (this.state.companiesState !== 'success') {
                this.setState({ companiesState: 'error' });
            }
        }
        return false;
    }

    inputConfirmAlertNext = (e) => {
        if (this.isValidated()) {
            this.props.onSubmit(this.state);
            this.props.onCancel();
        }
    };

    verifyEmail = (value) => {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRex.test(value);
    };
    verifyPhone = (value) => {
        var phoneRex = /^\d{7}$/;
        return phoneRex.test(value);
    };
    verifyKennitala = (value) => {
        var kennitalaRex = /^\d{10}$/;
        return kennitalaRex.test(value);
    };

    change(data) {
        let result = data.replace(/^\s+|\s+$/g, '').split(/\s+/);
        this.setState({ users: data });
        let temp = [];
        for (var i = 0; i < result.length; i++) {
            if (
                this.verifyEmail(result[i]) ||
                this.verifyPhone(result[i]) ||
                this.verifyKennitala(result[i])
            ) {
                temp.push('ok');
            } else {
                temp.push('error');
            }
        }
        if (temp.includes('error')) {
            this.setState({ msg: "Villa í innslætti í '" + result[temp.indexOf('error')] + "'" });
        } else {
            this.setState({ msg: 'Allt rétt!' });
        }
    }

    handleChange = (company_id) => {
        let comps = this.state.companies;
        if (!comps.includes(company_id)) {
            comps.push(company_id);
        } else {
            comps.splice(comps.indexOf(company_id), 1);
        }
        this.setState({ companies: comps });
        this.setState({ companiesState: 'success' });
    };

    // Hjálparfall til að tryggja að companies sé alltaf array
    ensureCompaniesArray = (companies) => {
        if (!companies) return [];
        if (Array.isArray(companies)) return companies;
        return companies.split(',').map(Number);
    };

    // Síar hópa eftir leitarstrengi
    getFilteredCompanies = () => {
        const { companies } = this.props;
        const { searchQuery } = this.state;

        if (!companies) return [];
        if (!searchQuery.trim()) return companies;

        return companies.filter((comp) =>
            comp.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
    };

    // Skilar sýnilegum hópum (fyrstu 5 + valdir hópar, eða allir ef showAll eða leit er virk)
    getVisibleCompanies = () => {
        const { companies } = this.props;
        const { searchQuery, showAll, companies: selectedCompanies } = this.state;
        const filteredCompanies = this.getFilteredCompanies();
        const currentCompanies = this.ensureCompaniesArray(selectedCompanies);

        // Ef leit er virk, sýna allar síaðar niðurstöður + valda hópa
        if (searchQuery.trim()) {
            const visible = [];
            const seenIds = new Set();

            // Bæta við öllum síuðum niðurstöðum
            filteredCompanies.forEach((comp) => {
                visible.push(comp);
                seenIds.add(comp.id);
            });

            // Bæta við völdum hópum sem ekki eru í síuðum niðurstöðum
            if (companies) {
                companies.forEach((comp) => {
                    if (currentCompanies.includes(comp.id) && !seenIds.has(comp.id)) {
                        visible.push(comp);
                        seenIds.add(comp.id);
                    }
                });
            }

            // Raða í upprunalega röð
            return visible.sort((a, b) => {
                const allCompanies = companies || [];
                const indexA = allCompanies.findIndex((c) => c.id === a.id);
                const indexB = allCompanies.findIndex((c) => c.id === b.id);
                return indexA - indexB;
            });
        }

        // Ef sýna alla, sýna alla
        if (showAll) {
            return filteredCompanies;
        }

        // Annars sýna fyrstu 15 og alla valda
        const visible = [];
        const seenIds = new Set();

        // Bæta við fyrstu 15
        for (let i = 0; i < Math.min(15, filteredCompanies.length); i++) {
            visible.push(filteredCompanies[i]);
            seenIds.add(filteredCompanies[i].id);
        }

        // Bæta við völdum hópum sem ekki eru nú þegar sýnilegir
        filteredCompanies.forEach((comp) => {
            if (currentCompanies.includes(comp.id) && !seenIds.has(comp.id)) {
                visible.push(comp);
                seenIds.add(comp.id);
            }
        });

        // Raða í upprunalega röð
        return visible.sort((a, b) => {
            const indexA = filteredCompanies.findIndex((c) => c.id === a.id);
            const indexB = filteredCompanies.findIndex((c) => c.id === b.id);
            return indexA - indexB;
        });
    };

    // Handler fyrir leit
    handleSearch = (event) => {
        this.setState({ searchQuery: event.target.value });
    };

    // Toggle fyrir show all
    toggleShowAll = () => {
        this.setState((prevState) => ({ showAll: !prevState.showAll }));
    };

    render() {
        const { classesAdd, companies, t } = this.props;
        const hasMultipleCompanies = companies && companies.length > 1;
        const singleCompany = companies && companies.length === 1 ? companies[0] : null;

        // Tryggja að companies sé alltaf array
        const currentCompanies = this.ensureCompaniesArray(this.state.companies);

        return (
            <Dialog
                open={true}
                onClose={() => this.props.onCancel()}
                maxWidth={false}
                PaperProps={{ style: { width: '700px', maxWidth: '95vw', maxHeight: '95vh' } }}
                disableEscapeKeyDown
            >
                <DialogTitle>
                    {t(
                        hasMultipleCompanies
                            ? 'add_new_special_user_plural'
                            : 'add_new_special_user'
                    )}
                </DialogTitle>
                <DialogContent dividers>
                    <GridContainer justifyContent="space-between" container>
                        <GridItem
                            xs={12}
                            sm={12}
                            className={
                                this.state.msg === 'Allt rétt!'
                                    ? classesAdd.txtSuccess
                                    : classesAdd.error
                            }
                        >
                            {this.state.msg}
                        </GridItem>
                        <GridItem xs={12} sm={12}>
                            <TextareaAutosize
                                className={classesAdd.txtArea}
                                minRows={8}
                                maxRows={8}
                                id="description"
                                aria-label="description"
                                placeholder={t('add_employee_example')}
                                value={this.state.users}
                                onChange={(event) => this.change(event.target.value)}
                            />
                        </GridItem>

                        <GridItem xs={12} sm={12}>
                            {hasMultipleCompanies ? (
                                <>
                                    <h4 className={classesAdd.sectionTitle}>
                                        {t('select_companies', 'Veldu hópa')}
                                    </h4>
                                    <p className={classesAdd.sectionDescription}>
                                        {t(
                                            'select_companies_description',
                                            'Veldu þá hópa sem notendur eiga að hafa aðgang að. Þú getur valið fleiri en einn hóp.'
                                        )}
                                    </p>
                                    <GridItem xs={12} sm={12} style={{ marginBottom: '20px' }}>
                                        <input
                                            type="text"
                                            placeholder={t('search_groups', 'Leita að hópum...')}
                                            value={this.state.searchQuery}
                                            onChange={this.handleSearch}
                                            style={{
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '4px',
                                                fontSize: '14px',
                                            }}
                                        />
                                    </GridItem>
                                    <div
                                        style={{
                                            maxHeight: '450px',
                                            overflowY: 'auto',
                                            overflowX: 'hidden',
                                            marginBottom: '10px',
                                            paddingRight: '5px',
                                        }}
                                    >
                                        <div className={classesAdd.companiesGrid}>
                                            {this.getVisibleCompanies().map((comp) => {
                                                const isSelected = currentCompanies.includes(
                                                    comp.id
                                                );
                                                return (
                                                    <div
                                                        className={classesAdd.companyItem}
                                                        key={`company-${comp.id}`}
                                                    >
                                                        <div
                                                            className={`${
                                                                classesAdd.companyCheckbox
                                                            } ${
                                                                isSelected
                                                                    ? classesAdd.iconSelected
                                                                    : ''
                                                            }`}
                                                            onClick={() =>
                                                                this.handleChange(comp.id)
                                                            }
                                                            role="button"
                                                            tabIndex={0}
                                                            onKeyPress={(e) => {
                                                                if (
                                                                    e.key === 'Enter' ||
                                                                    e.key === ' '
                                                                ) {
                                                                    this.handleChange(comp.id);
                                                                }
                                                            }}
                                                            style={{
                                                                border: isSelected
                                                                    ? '2px solid #C42431'
                                                                    : '2px solid #e0e0e0',
                                                            }}
                                                        >
                                                            <div
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                <Checkbox
                                                                    checked={isSelected}
                                                                    tabIndex={-1}
                                                                    title={comp.name}
                                                                    alt={comp.name}
                                                                    onChange={() =>
                                                                        this.handleChange(comp.id)
                                                                    }
                                                                />
                                                            </div>
                                                            <img
                                                                src={comp.logo}
                                                                className={classesAdd.logoImg}
                                                                alt={comp.name}
                                                            />
                                                            <span
                                                                className={classesAdd.companyName}
                                                            >
                                                                {comp.name}
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {!this.state.searchQuery.trim() &&
                                        !this.state.showAll &&
                                        companies &&
                                        companies.length > 15 && (
                                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                                <button
                                                    onClick={this.toggleShowAll}
                                                    style={{
                                                        padding: '10px 30px',
                                                        backgroundColor: '#C42431',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    {t('show_more', 'Sýna fleiri')}
                                                </button>
                                            </div>
                                        )}
                                </>
                            ) : (
                                singleCompany && (
                                    <div className={classesAdd.singleCompanyInfo}>
                                        <div className={classesAdd.singleCompanyHeader}>
                                            <img
                                                src={singleCompany.logo}
                                                className={classesAdd.logoImg}
                                                alt={singleCompany.name}
                                            />
                                            <h4 className={classesAdd.sectionTitle}>
                                                {t(
                                                    'adding_to_group',
                                                    'Þú ert að bæta við meðlimum í hópinn'
                                                )}{' '}
                                                „{singleCompany.name}“
                                            </h4>
                                        </div>
                                    </div>
                                )
                            )}
                        </GridItem>
                        <GridItem
                            xs={12}
                            sm={12}
                            className={
                                this.state.companiesState === 'error'
                                    ? classesAdd.error
                                    : classesAdd.txtSuccess
                            }
                        >
                            {this.state.companiesState === 'error' &&
                                'Vinsamlega veldu hóp til að gefa aðgang að'}
                        </GridItem>
                        <GridItem xs={12} sm={12} style={{ marginTop: 16 }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: 8,
                                    cursor: 'pointer',
                                }}
                                onClick={() =>
                                    this.setState((prev) => ({
                                        notify_app_users: !prev.notify_app_users,
                                    }))
                                }
                                role="button"
                                tabIndex={0}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        this.setState((prev) => ({
                                            notify_app_users: !prev.notify_app_users,
                                        }));
                                    }
                                }}
                            >
                                <Checkbox
                                    checked={!!this.state.notify_app_users}
                                    onChange={() =>
                                        this.setState((prev) => ({
                                            notify_app_users: !prev.notify_app_users,
                                        }))
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                />
                                <div>
                                    <div style={{ fontWeight: 500, fontSize: 14 }}>
                                        {t(
                                            'notify_app_users',
                                            'Senda tilkynningu á þá sem þegar hafa appið'
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: 13,
                                            color: '#666',
                                            marginTop: 2,
                                        }}
                                    >
                                        {t(
                                            'notify_app_users_description',
                                            'Notendur með Spara-appið fá push-tilkynningu um nýjan hópaðgang.'
                                        )}
                                    </div>
                                </div>
                            </div>
                        </GridItem>
                    </GridContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.props.onCancel()} color="error">
                        {t('cancel')}
                    </Button>
                    <Button
                        onClick={() => this.inputConfirmAlertNext()}
                        variant="contained"
                        color="success"
                    >
                        {t('save')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation('', { withRef: true })(addSpecialUser);
